module.exports = __webpack_public_path__ + "static/media/deletenew.c36dbede.svg";